import { ShieldAlert, User, LogOut, ArrowRight } from 'lucide-react';

export const Profile = ({ isLight, handleLogout, user, onNavigate }) => {
  const isAnonymous = user?.isAnonymous;

  return (
    <div className={`rounded-lg p-10 md:p-14 border relative transition-all duration-500 animate-in shadow-2xl ${
      isLight ? 'bg-white/80 border-slate-200' : 'bg-[#111114]/80 border-white/10'} backdrop-blur-md`}>
      
      <div className="flex flex-col items-center text-center mb-10">
        <div className={`w-20 h-20 rounded-3xl flex items-center justify-center mb-6 border-2 ${
          isAnonymous ? 'bg-orange-500/10 border-orange-500/30' : 'bg-cyan-500/10 border-cyan-500/30'
        }`}>
          {isAnonymous ? <ShieldAlert className="text-orange-500" size={32} /> : <User className="text-cyan-500" size={32} />}
        </div>
        
        <h3 className="text-2xl font-black italic tracking-tighter uppercase mb-2">
          {isAnonymous ? 'Guest Identity' : (user?.displayName || 'Active Member')}
        </h3>
        <p className={`text-[10px] font-mono uppercase tracking-[0.3em] ${isLight ? 'text-slate-500' : 'text-slate-400'}`}>
          {isAnonymous ? 'Temporary Trial Session' : user?.email}
        </p>
      </div>

      <div className="space-y-4">
        {isAnonymous && (
          <button 
            onClick={() => onNavigate('/register')}
            className={`w-full font-black py-5 rounded uppercase text-xs tracking-[0.15em] transition-all flex items-center justify-center gap-2 border-2 border-cyan-500 text-cyan-500 hover:bg-cyan-500 hover:text-black shadow-[0_0_20px_rgba(6,182,212,0.1)]`}
          >
            Claim Full Account <ArrowRight size={14} />
          </button>
        )}

        <button 
          onClick={handleLogout}
          className={`w-full font-black py-5 rounded uppercase text-xs tracking-[0.15em] transition-all duration-300 flex items-center justify-center gap-2 ${
            isLight ? 'bg-slate-900 text-white hover:bg-slate-800' : 'bg-white text-black hover:bg-slate-200'
          } disabled:opacity-50`}
        >
          <LogOut size={14} /> {isAnonymous ? 'Discard Session' : 'Logout'}
        </button>
      </div>
    </div>
  );
};